import { RequestBuilder } from '../request_builder'

export class DetailsRequestBuilder extends RequestBuilder {
  constructor (serverUrl) {
    super(serverUrl)
    this.segment = 'details'
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/details_requests_builder.js